import BlogList from './BlogList';
import BlogCreate from './BlogCreate';
import BlogEdit from './BlogEdit';
import BlogCategoryManage from './BlogCategoryManage';
import BlogCommentManage from './BlogCommentManage';

const blogRoutes = [
  {
    name: 'Blog Posts',
    path: '/admin/dashboard/blog/posts',
    component: BlogList,
    exact: true,
  },
  {
    name: 'Add New Post',
    path: '/admin/dashboard/blog/posts/new',
    component: BlogCreate,
    exact: true,
  },
  {
    name: 'Edit Post',
    path: '/admin/dashboard/blog/posts/:slug/edit',
    component: BlogEdit,
    exact: true,
  },
  {
    name: 'Categories',
    path: '/admin/dashboard/blog/categories',
    component: BlogCategoryManage,
    exact: true,
  },
  // {
  //   name: 'Comments',
  //   path: '/admin/dashboard/blog/comments',
  //   component: BlogCommentManage,
  //   exact: true,
  // },
];

export default blogRoutes;